import { ReadonlyRecord } from '@bimser/core';
import { Record } from 'immutable';

interface IBaseProcessDetailsState {
	loading: boolean;
	pendingFastApproveDocumentCount: number;
}

export interface IProcessDetailsState extends IBaseProcessDetailsState {}

export interface IReadonlyProcessDetailsState extends IBaseProcessDetailsState {}

export type ProcessDetailsState = ReadonlyRecord<IReadonlyProcessDetailsState>;

export const ProcessDetailsStateFactory = Record<IReadonlyProcessDetailsState>({
	loading: false,
	pendingFastApproveDocumentCount: 0
});

export const ProcessDetailsStateFactoryFromJS = function (data: IProcessDetailsState) {
	return ProcessDetailsStateFactory({
		...data
	});
};
